import { parseMetaFlowJson } from './metaFlowUtils';

/** 與 MetaFlowFieldDisplaySetting.js 的 INPUT_COMPONENT_TYPES 一致；這些 type 的 name 會出現在 response_json key。 */
const INPUT_COMPONENT_TYPES = new Set([
  'text_input',
  'text_area',
  'date_picker',
  'calendar_picker',
  'time_picker',
  'select',
  'checkbox',
  'radio',
  'chips_selector',
  'photo_picker',
  'document_picker',
  'opt_in',
]);

/**
 * 從 EFormDefinition.metaFlowJson 建立 field name → 畫面上標題（title / label）。
 * 不依賴 FieldDisplaySettings（列表顯示設定），未開列表設定也能顯示正確標籤。
 *
 * @param {string|object|null|undefined} metaFlowJson - DB 儲存的 Meta Flow JSON 字串或物件
 * @returns {Record<string, string>}
 */
export function buildFieldLabelMapFromMetaFlowJson(metaFlowJson) {
  if (metaFlowJson == null || metaFlowJson === '') return {};
  try {
    const { screens } = parseMetaFlowJson(metaFlowJson);
    if (!Array.isArray(screens) || screens.length === 0) return {};
    const map = {};
    const seen = new Set();
    screens.forEach((screen) => {
      const actions = screen?.data?.actions || [];
      actions.forEach((action) => {
        if (!action || !INPUT_COMPONENT_TYPES.has(action.type)) return;
        const fieldId = action.name || action.id;
        if (!fieldId || seen.has(fieldId)) return;
        seen.add(fieldId);
        const label =
          action.title ||
          action.label ||
          action.data?.label ||
          fieldId;
        map[fieldId] = label;
      });
    });
    return map;
  } catch {
    return {};
  }
}

/**
 * 合併標籤：以 Meta Flow builder 定義為主；若 FieldDisplaySettings 裡有非空的 displayLabel，則覆寫（列表設定裡手動改名時生效）。
 *
 * @param {string|object|null|undefined} metaFlowJson
 * @param {string|Array|null|undefined} fieldDisplaySettings
 * @returns {Record<string, string>}
 */
export function mergeFlowFieldLabels(metaFlowJson, fieldDisplaySettings) {
  const fromBuilder = buildFieldLabelMapFromMetaFlowJson(metaFlowJson);
  const overrides = {};
  if (fieldDisplaySettings) {
    try {
      let settings = fieldDisplaySettings;
      if (typeof settings === 'string') settings = JSON.parse(settings);
      if (Array.isArray(settings)) {
        settings.forEach((s) => {
          const id = s.fieldId || s.FieldId;
          if (!id) return;
          const dl = (s.displayLabel ?? s.DisplayLabel ?? '').toString().trim();
          if (dl) overrides[id] = dl;
        });
      }
    } catch {
      /* ignore */
    }
  }
  return { ...fromBuilder, ...overrides };
}
